import { useState } from "react";
import useCustomer from "../../context/CustomerContext";
import { useFavoriteCustomerMutation, useGetCustomerQuery } from "../../features/customer/customerSlice";
import ListLayout from "../Shared/ListLayout";
import CustomerDetailstab from "./CustomerDetails";

const CustomerList = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { data, refetch, isLoading } = useGetCustomerQuery();
  const [favoriteCustomer] = useFavoriteCustomerMutation();
  const { handleAccount } = useCustomer();
  const customerData = data?.data || [];

  // Handle favorite action for a customer
  const handleFavorite = async (account_No) => {
    await favoriteCustomer(account_No);
    refetch();
  };

  // Handle selecting a customer item
  const handleItemSelect = (item) => {
    handleAccount(item.account_No);
  };

  return (
    <ListLayout
      items={customerData}
      isLoading={isLoading}
      onFavorite={handleFavorite}
      onItemSelect={handleItemSelect}
      selectedIndex={selectedIndex}
      setSelectedIndex={setSelectedIndex}
    >
      <div>
        <CustomerDetailstab />
      </div>
    </ListLayout>
  );
};

export default CustomerList;
